import { render, staticRenderFns } from "./otb.vue?vue&type=template&id=3578caae&"
import script from "./otb.vue?vue&type=script&lang=js&"
export * from "./otb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports